import {useState} from "react";

import {DropdownAction, DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {Incident} from "@/lib/types/statuspages.ts";
import {IncidentDelete} from "@/pages/incidents/actions/IncidentDelete.tsx";
import {IncidentEditAction} from "@/pages/incidents/actions/IncidentEditAction.tsx";

interface IncidentsTableActionsProps {
  incident: Incident;
}

export const IncidentsTableActions = ({incident}: IncidentsTableActionsProps) => {
  const [showDelete, setShowDelete] = useState(false);

  return (
    <>
      <IncidentDelete
        statusPageID={incident.statuspage.id}
        incidentID={incident.id}
        incidentName={incident.name}
        show={showDelete}
        setShow={setShowDelete}
      />
      <QuickActionsBar
        id={`incident-actions-${incident.id}`}
        actions={[
          <DropdownAction
            id={`incident-delete-${incident.id}`}
            items={[
              <IncidentEditAction
                variant="dropdownMenuItem"
                typography="normal"
                incidentId={incident.id}
                incidentType={incident.incident_type}
              >
                Edit
              </IncidentEditAction>,
              <DropdownActionItem text="Delete" onClick={() => setShowDelete(true)} />,
            ]}
          />,
        ]}
      />
    </>
  );
};
